"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OnEscape_1 = require("./OnEscape");
exports.default = OnEscape_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/behaviors/OnEscape/index.js
// module id = 1837
// module chunks = 8